import {
    OrbitComponentWithState
} from "../../../../base-components/orbit-component-with-state/orbit-component-with-state";
import {
    IFreePlayVoucherViewModel
} from "../../../../../services/free-play/vouchers/free-play-voucher-view-model.interface";
import {VoucherCardFaceHeaderBox} from "../../../boxes/voucher-card/face/header/voucher-card-face-header.box";
import React from "react";

interface VoucherCardFaceHeaderComponentProps {
    voucher: IFreePlayVoucherViewModel;
    onClick?: () => void;
}

interface VoucherCardFaceHeaderComponentState {
    expirationMessage: string;
}

export class VoucherCardFaceHeaderComponent extends OrbitComponentWithState<VoucherCardFaceHeaderComponentProps, VoucherCardFaceHeaderComponentState> {

    constructor(props: VoucherCardFaceHeaderComponentProps) {
        super(props);
        this.state = {
            expirationMessage: props.voucher.expirationMessage
        };
    }

    private _expirationTimer: any = null;



    componentDidMount() {
        super.componentDidMount();
        if(this.props.voucher.isCloseToExpiration) {
            this._expirationTimer = setInterval(() => {
                this.setState({
                    expirationMessage: this.props.voucher.expirationMessage
                })
            }, 1000);
        }
    }

    componentWillUnmount() {
        super.componentWillUnmount();
        if(this._expirationTimer) {
            clearInterval(this._expirationTimer);
        }
    }

    render() {
        return (
            <VoucherCardFaceHeaderBox onClick={this.props.onClick} isCloseToExpiration={this.props.voucher.isCloseToExpiration}>
                {this.props.voucher.expirationMessage}
            </VoucherCardFaceHeaderBox>
        );
    }
}